export enum Language {
  de = "de",
  en = "en",
}
